import MessageHeader from "./MessageHeader";
import {
  FilteredChatContext,
  FilteredChatMessagesContext,
  MessagePanelProvider,
  OrganizationContext,
  RecipientInfoProvider,
  UnSupportedChatProvider,
  UploadProgress,
  useTranslation,
} from "hhn-commons";
import { MessagePanel } from "./MessagePanel";
import RecipientInfo from "./messagePanelMenu/recipientInfo/RecipientInfo";
import { useContext } from "react";
import { Typography } from "@mui/material";
import { CaptionWrapper } from "./MessagePanel.style";
import ForwardMessagesActionPanel from "./messagePanelMenu/forwardTo/ForwardMessagesActionPanel";
type FilteredMessageListViewProps = {
  onSearchClear: () => void;
  fileProgressStatus: UploadProgress;
  isUploadFailed: boolean;
  openFileDialog: () => void;
};

const FilteredMessageListView = ({
  onSearchClear,
}: FilteredMessageListViewProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  const { selectedOrgUser } = useContext(OrganizationContext);
  const { chat, isChatLoading } = useContext(FilteredChatContext);

  const { scrollMessages, isMessageLoading, applyFilters } = useContext(
    FilteredChatMessagesContext,
  );

  const isMember = chat?.isMember() ?? false;

  return (
    <>
      {!!chat && (
        <UnSupportedChatProvider>
          <MessageHeader
            chatAccess={chat}
            showSearch={true}
            setShowSearch={onSearchClear}
            onFilter={applyFilters}
            isMemberFlag={isMember}
            isChatLoading={isChatLoading}
          />
          <MessagePanelProvider>
            <RecipientInfoProvider>
              {selectedOrgUser && (
                <MessagePanel
                  chatAccess={chat}
                  selectedOrgUser={selectedOrgUser}
                  scrollMessages={scrollMessages}
                  isMessageLoading={isMessageLoading}
                />
              )}
              <CaptionWrapper data-testid="InputCaption">
                <Typography style={{ fontWeight: 500 }} variant={"body1"}>
                  {tNs("search.caption")}
                </Typography>
              </CaptionWrapper>
              <ForwardMessagesActionPanel />
              <RecipientInfo chatInfoAccess={chat} />
            </RecipientInfoProvider>
          </MessagePanelProvider>
        </UnSupportedChatProvider>
      )}
    </>
  );
};

export default FilteredMessageListView;
